import React, { useState } from "react";
import "../styles/contactform.css";

function Contactform() {
  const [statusMsg, setStatusMsg] = useState("");
  const [msgType, setMsgType] = useState(""); // for styling (success/error)

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    try {
      const response = await fetch("/contactform.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.text();

      if (response.ok && result.toLowerCase().includes("success")) {
        setStatusMsg(result);
        setMsgType("success");
        e.target.reset(); // Reset form after successful submit
      } else {
        setStatusMsg(result);
        setMsgType("error");
      }
    } catch (error) {
      setStatusMsg("Failed to send message. Please try again later.");
      setMsgType("error");
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-bg-circles">
        <div className="contact-circle large"></div>
        <div className="contact-circle small"></div>
      </div>
      <form className="contact-form" onSubmit={handleSubmit}>
        <h2 className="contact-title">Get in touch for free consultation</h2>
        <div className="contact-subtitle">
          Your information is 100% secure & confidential
        </div>
        <div className="contact-row">
          <div className="contact-field">
            <label>First Name</label>
            <input type="text" name="firstName" required />
          </div>
          <div className="contact-field">
            <label>Last Name</label>
            <input type="text" name="lastName" required />
          </div>
        </div>
        <div className="contact-row">
          <div className="contact-field">
            <label>Email</label>
            <input type="email" name="email" required />
          </div>
          <div className="contact-field">
            <label>Phone Number</label>
            <input type="text" name="phone" required />
          </div>
        </div>
        <div className="contact-field" style={{ marginBottom: 20 }}>
          <label>Select Subject?</label>
          <div className="contact-radio-group">
            <label>
              <input
                type="radio"
                name="subject"
                value="General Inquiry"
                defaultChecked
              />
              <span className="custom-radio"></span>
              <span>General Inquiry</span>
            </label>
            <label>
              <input type="radio" name="subject" value="Financial Planning" />
              <span className="custom-radio"></span>
              <span>Financial Planning</span>
            </label>
            <label>
              <input type="radio" name="subject" value="Insurance Solutions" />
              <span className="custom-radio"></span>
              <span>Insurance Solutions</span>
            </label>
            <label>
              <input type="radio" name="subject" value="Real Estate" />
              <span className="custom-radio"></span>
              <span>Real Estate</span>
            </label>
          </div>
        </div>
        <div className="contact-field" style={{ marginBottom: 20 }}>
          <label>Message</label>
          <textarea
            name="message"
            required
            placeholder="Write your message ..."
          ></textarea>
        </div>
        <button type="submit" className="contact-submit">
          Send Message
        </button>

        {/* Show the status message if available */}
        {statusMsg && (
          <div
            className={`contact-status-message ${
              msgType === "success" ? "success" : "error"
            }`}
            style={{
              marginTop: "18px",
              color: msgType === "success" ? "#28a745" : "#dc3545",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            {statusMsg}
          </div>
        )}
      </form>
    </section>
  );
}

export default Contactform;
